export const Theme = {
  DEFAULT: 'default',
  ORANGE: 'orange',
} as const;

export type Theme = (typeof Theme)[keyof typeof Theme];

export const StyleVariant = {
  DEFAULT: 'default',
  PLAYFUL: 'playful',
  BRUTALIST: 'brutalist',
} as const;

export type StyleVariant = (typeof StyleVariant)[keyof typeof StyleVariant];

export const Mode = {
  DARK: 'dark',
  LIGHT: 'light',
  SYSTEM: 'system',
} as const;

export type Mode = (typeof Mode)[keyof typeof Mode];
